export const CUSTOM_EVENTS = {
  grab_bulk: 'grab_bulk',
  graph_sector_loaded: 'graph_sector_loaded',
  drag_bulk: 'drag_bulk',
  dragfree_bulk: 'dragfree_bulk',
};
